import { PERSONAL_DATA } from '@/constants/personalData';
import { INSTALLATION_ADDRESS } from '../installationAddress';

const {
  HORIZONTAL_ADDRESS,
  VERTICAL_ADDRESS,
  PROVINCE,
  POSTAL_CODE,
  ADDRESS,
  ADDRESS_DETAIL,
} = INSTALLATION_ADDRESS;
const { DOC_NUMBER, NAME, LAST_NAME, SECOND_SURNAME, EMAIL, CONTACT_PHONE } =
  PERSONAL_DATA;

export const ORION_TEXTS_IDS = {
  SHOP: 'pc-mimovistar-shop',
  DIGITAL_DELIVERY: 'pc-mimovistar-digital-delivery',
  SHOP_DIGITAL_DELIVERY: 'pc-mimovistar-shop-digital-delivery',
  DELIVERY: 'pc-mimovistar-delivery',
  PORTABILITY: 'pc-mimovistar-porta',
  CART: 'pc-mimovistar-carro-envio',
  CART_LEGALS: 'pc-mimovistar-legales-carro-genericos',
  LEGALS: 'pc-mimovistar-legales-carro-genericos',
  UPDATE_NOTE: 'pc-mimovistar-update-note',
  LM_SHOP: 'pc-mimovistar-lm-shop',
  XGSPON_MODAL: 'pc-mimovistar-xgspon',
  XGSPON10: 'PC-CAPA-MIMOVISTAR-XGPSON_10EUROS',
  XGSPON5: 'PC-CAPA-MIMOVISTAR-XGPSON_5EUROS',
};

export const FORM_ID = {
  GP: 'FORM_MIMOVISTAR_GP',
  AU: 'FORM_MIMOVISTAR_AU',
};
export const CONFIRMATION_ID = {
  GP: 'CONFIRMATION_MIMOVISTAR_GP',
  AU: 'CONFIRMATION_MIMOVISTAR_AU',
};
export const CONFIRM_PATH = {
  dev: '/gp/mimovistar/confirmacion/',
  qa: '/order/gp/mimovistar/confirmacion/',
  prod: '/order/gp/mimovistar/confirmacion/',
};
export const CONFIRM_PATH_AU = {
  dev: '/au//mimovistar/confirmacion/',
  qa: '/order/au/mimovistar/confirmacion/',
  prod: '/order/au/mimovistar/confirmacion/',
};

export const URL_SEO = 'www.movistar.es/order/gp/mimovistar';
export const PATH_NAME = {
  GP: '/order/gp/mimovistar',
  AU: '/order/gp/mimovistar',
};
export const PERSONAL_DATA_IDS = {
  GP: [
    DOC_NUMBER.ID,
    NAME.ID,
    LAST_NAME.ID,
    SECOND_SURNAME.ID,
    EMAIL.ID,
    CONTACT_PHONE.ID,
    HORIZONTAL_ADDRESS.ID,
    VERTICAL_ADDRESS.ID,
    PROVINCE.ID,
    POSTAL_CODE.ID,
    ADDRESS.ID,
    ADDRESS_DETAIL.ID,
  ],
};
export const CHARACTERISTICS_TYPES = {
  COLOR: '20',
  CAPACIDAD: '21',
  OTT: '43',
  // MPA: 309 o 49
  MPA: '49',
  SPEED: '13',
};
export const PHONE_900 = '900 104 430';
export const HOME_URL = 'https://www.movistar.es/fibra-y-movil/';
export const TRANSACTION_TYPE = 'mimovistar';
